/**
 * axios setup to use mock service
 */
import React from 'react';
import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';

// Create axios instance with cache interceptor
const axiosServices = setupCache(axios.create(), {
    ttl: 5 * 60 * 1000 // 5 minutes cache
});

axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(console.log(error.response && error.response) || {status: 500, data: 'internal server error'})
);


export default axiosServices;


